import Close from './Close';

export default Close;